import React from 'react'

const CompanyNames = {
  boa: (<span>Bank&nbsp;of&nbsp;America</span>)
}

export default CompanyNames
